module.exports = __webpack_public_path__ + "img/coreModule12.519d92de.jpg";